(() => {
  if (window.KASK50Product) { window.KASK50Product.refresh(); return; }
  const controllers = new Map();
  const normaliseWidth = value => String(value || '').toLowerCase().replace(/\s/g, '');
  const mount = root => {
    if (controllers.has(root)) return;
    const selection = root.querySelector('variant-selection');
    const summary = root.querySelector('[data-kas-selection-value]');
    const section = root.closest('.shopify-section');
    const dataNode = section?.querySelector('[data-section-data]');
    if (!selection || !summary || !dataNode) return;
    let product;
    try { product = JSON.parse(dataNode.textContent).product; } catch { return; }
    if (!product) return;
    const detailSections = () => Array.from(document.querySelectorAll('[data-kas-k50-details]')).filter(element => element.dataset.kasProductId === String(product.id));
    const widthIndex = (product.options || []).findIndex(option => String(option.name || option).toLowerCase().includes('width'));
    const update = detail => {
      const variant = detail?.variant;
      if (product.variants.length > 1) {
        if (variant) summary.textContent = variant.options.join(' · ');
        else summary.textContent = Array.from(selection.querySelectorAll('input[type="radio"]:checked')).map(input => input.value).join(' · ');
      }
      const width = widthIndex >= 0 && variant ? normaliseWidth(variant.options[widthIndex]) : '';
      detailSections().forEach(details => {
        const addOnNode = details.querySelector('[data-kas-add-on-data]');
        const addOnLink = details.querySelector('[data-kas-add-on-link]');
        if (addOnNode && addOnLink && variant) {
          try {
            const addOn = JSON.parse(addOnNode.textContent);
            const dimensions = {};
            product.options.forEach((option, index) => {
              const name = String(option.name || option).toLowerCase();
              if (name.includes('width')) dimensions.width = normaliseWidth(variant.options[index]);
              if (name.includes('height')) dimensions.height = normaliseWidth(variant.options[index]);
            });
            const match = addOn.variants.find(candidate => addOn.options.every((option, index) => {
              const name = String(option.name || option).toLowerCase();
              if (name.includes('width') && dimensions.width) return normaliseWidth(candidate.options[index]) === dimensions.width;
              if (name.includes('height') && dimensions.height) return normaliseWidth(candidate.options[index]) === dimensions.height;
              return true;
            }));
            addOnLink.href = match ? `${addOn.url}?variant=${match.id}` : addOn.url;
          } catch {}
        }
        details.querySelectorAll('[data-kas-shelf-width]').forEach(card => {
          card.hidden = !width || normaliseWidth(card.dataset.kasShelfWidth) !== width;
        });
      });
    };
    const listener = event => update(event.detail);
    selection.addEventListener('variant-change', listener);
    const selectedId = selection.getAttribute('variant');
    update({variant: product.variants.find(variant => String(variant.id) === selectedId)});
    controllers.set(root, {cleanup: () => selection.removeEventListener('variant-change', listener), update, selection});
  };
  const initialise = scope => {
    if (scope.matches?.('[data-kas-k50-main]')) mount(scope);
    scope.querySelectorAll('[data-kas-k50-main]').forEach(mount);
  };
  const refresh = () => {
    initialise(document);
    controllers.forEach((controller, root) => {
      if (!root.isConnected) { controller.cleanup(); controllers.delete(root); }
    });
    controllers.forEach(({selection, update}) => {
      if (typeof selection.getVariant === 'function') {
        selection.getVariant().then(variant => {
          update({variant});
        }).catch(() => {});
      }
    });
  };
  window.KASK50Product = {refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
})();
